export const hosts = {
  prod: 'https://mmcapi.ads.microsoft.com/',
  betasi: 'https://beta.mmcapi.ads-int.microsoft.com/',
  si: 'https://mmcapi.ads-int.microsoft.com/',
  ci: 'https://ci.mmcapi.ads-int.microsoft.com/',
  dev: 'https://localhost:443/',
};
